!function() {
  var t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {}, e = {}, i = {}, n = t.parcelRequire5f74;
  null == n && ((n = function(t) {
    if (t in e) return e[t].exports;
    if (t in i) {
      var n = i[t];
      delete i[t];
      var o = {
        id: t,
        exports: {}
      };
      return e[t] = o, n.call(o.exports, o, o.exports), o.exports;
    }
    var r = new Error("Cannot find module '" + t + "'");
    throw r.code = "MODULE_NOT_FOUND", r;
  }).register = function(t, e) {
    i[t] = e;
  }, t.parcelRequire5f74 = n), (0, n.register)("kmbQD", function(t, e) {
    var i, n, o, r;
    i = t.exports, n = "default", o = function() {
      return a;
    }, Object.defineProperty(i, n, {
      get: o,
      set: r,
      enumerable: !0,
      configurable: !0
    });
    class a {
      static doChange({id: t, quantity: e, properties: i = {}}, n = !1) {
        return fetch(`${Shopify.routes.root || "/"}cart/change.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            id: t,
            quantity: e,
            properties: {
              ...i
            }
          })
        }).then(t => {
          if (!t.ok) throw new Error("Cart change failed");
          return t.ok && n && this.update(!0), t;
        }).catch(t => t);
      }
      static doUpdate(t, e, i = !1) {
        const n = Array.isArray(t) ? t.reduce((t, i) => ({
          ...t,
          [i]: e
        }), {}) : {
          id: e
        };
        return fetch(`${Shopify.routes.root || "/"}cart/update.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            updates: n
          })
        }).then(t => {
          if (!t.ok) throw new Error("Cart update failed");
          return t.ok && i && this.update(!0), t;
        }).catch(t => t);
      }
      static doAdd({id: t, quantity: e, properties: i = {}}, n = !1, o = !0) {
        return fetch(`${Shopify.routes.root || "/"}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            items: [ {
              id: t,
              quantity: e,
              properties: {
                ...i
              }
            } ]
          })
        }).then(e => {
          if (!e.ok) throw new Error("Cart add failed");
          return e.ok && o ? (window.dispatchEvent(new CustomEvent("product:added", {
            detail: {
              variantId: t
            }
          })), e) : e.ok && n ? (this.update(!0), e) : void 0;
        }).catch(t => t);
      }
      static getCart() {
        return fetch(`${Shopify.routes.root || "/"}cart.js`, {
          method: "GET",
          headers: {
            Accept: "application/json"
          }
        }).then(t => {
          if (!t.ok) throw new Error("Failed to fetch cart");
          return t;
        }).catch(t => t);
      }
      static cleanupTeleportedContent() {
        document.querySelectorAll("[data-teleport-origin]").forEach(t => {
          t.remove();
        });
      }
      static update(t = !1, e = "cart-drawer", i = null) {
        try {
          e = e.replace("cart-drawer", document.querySelector("cart-drawer").closest(".shopify-section").getAttribute("id").match(/shopify-section-(.*)$/)[1]);
        } catch (t) {}
        try {
          e = e.replace("cart-notification", document.querySelector("cart-notification").closest(".shopify-section").getAttribute("id").match(/shopify-section-(.*)$/)[1]);
        } catch (t) {}
        (e = e.split(",")).push("header"), e = [ ...new Set(e) ];
        const n = document.getElementById("Cart"), o = !!t || n && n.checked;
        return fetch(`${location.pathname}?sections=${e.join(",")}`, {
          method: "GET"
        }).then(t => t.json()).then(t => {
          this.cleanupTeleportedContent(), Object.entries(t).forEach(t => {
            const [e, n] = t, r = (new DOMParser).parseFromString(n, "text/html");
            if (e.includes("cart-notification")) {
              const t = document.querySelector("cart-notification"), e = r.querySelector("cart-notification");
              t && e && (t.innerHTML = e.innerHTML);
            }
            i ??= [ `[id^="shopify-section-"][id$="${e}"]` ], i.push("header [data-cart-count-desktop]", "header [data-cart-count-mobile]", "form [data-cart-count]", "[data-cart-link]"), 
            i.forEach(t => {
              document.querySelectorAll(t).forEach(e => {
                const i = r.querySelector(t);
                i && (e.innerHTML = o ? i.innerHTML.replace('id="Cart"', 'id="Cart" checked') : i.innerHTML);
              });
            });
          });
        });
      }
    }
  });
  var o = n("kmbQD");
  class r extends HTMLElement {
    constructor() {
      super(), this.toggle = document.getElementById("Cart"), this.swat = null, this.setupSwymIntegration();
    }
    setupSwymIntegration() {
      if (!0 !== Shopify.MBF.wishlistEnabled) return void console.log("CartDrawer: Wishlist functionality is disabled, skipping Swym integration");
      const t = Date.now(), e = () => {
        window.Swym && "function" == typeof window.Swym.registerComponent ? window.Swym.registerComponent(t => {
          this.swat = t, this.initializeSwymButtons();
        }) : Date.now() - t < 3e4 ? setTimeout(e, 100) : console.warn("Swym utility did not become available within 30 seconds for cart-drawer component");
      };
      e();
    }
    initializeSwymButtons() {
      !0 === Shopify.MBF.wishlistEnabled && this.swat && this.swat.initializeActionButtons("cart-drawer");
    }
    connectedCallback() {
      this.addEventListener("click", this.onClickHandler.bind(this)), this.toggle && this.toggle.addEventListener("change", this.onToggleChange.bind(this)), 
      !location.hash.includes("Cart") || this.toggle && this.toggle.checked || this.open(), 
      this.initializeSwymButtons(), document.addEventListener("cart:updated", this.onCartUpdated.bind(this));
    }
    onCartUpdated() {
      setTimeout(() => {
        this.initializeSwymButtons();
      }, 100);
    }
    disconnectedCallback() {
      document.removeEventListener("cart:updated", this.onCartUpdated.bind(this));
    }
    open() {
      this.toggle && (this.toggle.checked = !0, this.toggle.dispatchEvent(new Event("change")), 
      o.default.update(!0), setTimeout(() => {
        this.initializeSwymButtons();
      }, 100));
    }
    close() {
      this.toggle && (this.toggle.dispatchEvent(new Event("change")), this.toggle.checked = !1);
    }
    onToggleChange() {
      this.toggle && (this.toggle.checked ? setTimeout(() => {
        document.body.classList.add("overflow-hidden");
      }) : document.body.classList.remove("overflow-hidden"));
    }
    onClickHandler(t) {
      if (!t.target.hasAttribute("data-ajax")) return;
      t.preventDefault();
      const e = t.target.hasAttribute("data-update"), i = t.target.getAttribute("data-id"), n = parseInt(t.target.getAttribute("data-quantity"));
      e && o.default.doUpdate(i.split(","), n, !0).then(() => {
        setTimeout(() => {
          this.initializeSwymButtons();
        }, 200);
      });
    }
  }
  customElements.get("cart-drawer") || customElements.define("cart-drawer", r);
}();